import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../select/eager-select/eager-select-reducer';
import { LogLevelOption } from '../models/log-level-option.interface';
import { LogLevels } from '../models/log-level.enum';
import { logLevelOptionActions } from './log-level-option.actions';

export const logLevelOptionFeatureKey = 'logLevelOptions';

export type LogLevelOptionState = EagerSelectState<LogLevelOption>;

const adapter = createEagerSelectAdapter<LogLevelOptionState, LogLevelOption>({
   featureKey: logLevelOptionFeatureKey,
   selectId: (logLevel: LogLevelOption) => {
      return logLevel.logLevelId ?? '';
   },
});

export const logLevelOptionSelectors = adapter.getSelectors(filterLogLevelOption);

const initialState = adapter.getInitialState();

export const logLevelOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   logLevelOptionActions.search,
   logLevelOptionActions.searchReset,
   logLevelOptionActions.loadFromApi,
   logLevelOptionActions.loadFromApiSuccess,
   logLevelOptionActions.loadFromApiFailure
);

export function filterLogLevelOption<T extends LogLevelOption>(types: T[], searchText: string | null | undefined): T[] {
   const filteredOptions: T[] = Object.values(LogLevels)
      .filter((logLevel) => {
         if (searchText) {
            return logLevel.toLowerCase().includes(searchText.toLowerCase());
         } else {
            return true;
         }
      })
      .map((logLevelId) => {
         return { logLevelId } as T;
      });
   return filteredOptions;
}
